export enum ResponseAncillaryStatusEnum {
  Requested = 'Requested',
  Confirmed = 'Confirmed',
  Cancelled = 'Cancelled',
  Rejected = 'Rejected',
}

export enum ResponseAncillaryProviderGroupEnum {
  Baggage = 'Baggage',
  LoungeAccess = 'LoungeAccess',
  AirportAssistance = 'AirportAssistance',
  Meals = 'Meals',
  PriorityBoarding = 'PriorityBoarding',
  Seat = 'Seat',
}
